export const translations = {
  en: {
    appTitle: 'Kalinga Temple Trust Portal',
    login: 'Login',
    phoneNumber: 'Phone Number',
    password: 'Password',
    loginButton: 'Sign In',
    dashboard: 'Dashboard',
    members: 'Members',
    payments: 'Payments',
    familyTree: 'Family Tree',
    addMember: 'Add Member',
    logout: 'Logout',
    welcome: 'Welcome',
    totalMembers: 'Total Members',
    totalCollected: 'Total Collected',
    pendingPayments: 'Pending Payments',
    recentActivity: 'Recent Activity',
    memberName: 'Member Name',
    fatherName: "Father's Name",
    motherName: "Mother's Name",
    spouseName: "Spouse's Name",
    dateOfBirth: 'Date of Birth',
    address: 'Address',
    children: 'Children',
    addChild: 'Add Child',
    childName: 'Child Name',
    childDOB: 'Child DOB',
    childGender: 'Child Gender',
    male: 'Male',
    female: 'Female',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    actions: 'Actions',
    status: 'Status',
    amount: 'Amount',
    amountPaid: 'Amount Paid',
    amountDue: 'Amount Due',
    payNow: 'Pay Now',
    paymentHistory: 'Payment History',
    date: 'Date',
    method: 'Payment Method',
    reference: 'Reference',
    exportExcel: 'Export to Excel',
    memberDetails: 'Member Details',
    familyDetails: 'Family Details',
    paymentDetails: 'Payment Details',
    makePayment: 'Make Payment',
    confirmPayment: 'Confirm Payment',
    paymentSuccess: 'Payment Successful!',
    viewFamilyTree: 'View Family Tree',
    generation: 'Generation',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    paid: 'Paid',
    pending: 'Pending',
    overdue: 'Overdue',
    emailConfirmation: 'Email confirmation sent',
    profileUpdated: 'Profile updated successfully',
    memberAdded: 'Member added successfully',
    email: 'Email',
    selectLanguage: 'Language',
    myProfile: 'My Profile',
    taxAmount: 'Tax Amount',
    annualTax: 'Annual Tax Contribution',
    viewAll: 'View All',
    close: 'Close',
    changePassword: 'Change Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    resetPassword: 'Reset Password',
    defaultPassword: 'Default Password',
    passwordChanged: 'Password changed successfully',
    passwordReset: 'Password reset successfully',
    passwordMismatch: 'Passwords do not match',
    defaultPasswordNote: 'Default password is the phone number. Member can change it after login.',
    memberId: 'Member ID',
    announcements: 'Trust Announcements',
    upcomingEvents: 'Upcoming Events',
    meetings: 'Meetings',
    contentManagement: 'Content Management',
    tamilTyping: 'Tamil Typing'
  },
  ta: {
    appTitle: 'கலிங்க கோவில் அறக்கட்டளை போர்டல்',
    login: 'உள்நுழைவு',
    phoneNumber: 'தொலைபேசி எண்',
    password: 'கடவுச்சொல்',
    loginButton: 'உள்நுழைக',
    dashboard: 'முகப்பு',
    members: 'உறுப்பினர்கள்',
    payments: 'கொடுப்பனவுகள்',
    familyTree: 'குடும்ப மரம்',
    addMember: 'உறுப்பினரைச் சேர்க்கவும்',
    logout: 'வெளியேறு',
    welcome: 'வரவேற்பு',
    totalMembers: 'மொத்த உறுப்பினர்கள்',
    totalCollected: 'மொத்த வசூல்',
    pendingPayments: 'நிலுவை கொடுப்பனவுகள்',
    recentActivity: 'சமீபத்திய செயல்பாடு',
    memberName: 'உறுப்பினர் பெயர்',
    fatherName: 'தந்தை பெயர்',
    motherName: 'தாய் பெயர்',
    spouseName: 'வாழ்க்கைத்துணை பெயர்',
    dateOfBirth: 'பிறந்த தேதி',
    address: 'முகவரி',
    children: 'குழந்தைகள்',
    addChild: 'குழந்தையைச் சேர்க்கவும்',
    childName: 'குழந்தை பெயர்',
    childDOB: 'குழந்தை பிறந்த தேதி',
    childGender: 'குழந்தை பாலினம்',
    male: 'ஆண்',
    female: 'பெண்',
    submit: 'சமர்ப்பிக்கவும்',
    cancel: 'ரத்து செய்',
    save: 'சேமிக்கவும்',
    edit: 'திருத்து',
    delete: 'நீக்கு',
    view: 'காண்க',
    actions: 'செயல்கள்',
    status: 'நிலை',
    amount: 'தொகை',
    amountPaid: 'செலுத்திய தொகை',
    amountDue: 'நிலுவை தொகை',
    payNow: 'இப்போது செலுத்து',
    paymentHistory: 'கொடுப்பனவு வரலாறு',
    date: 'தேதி',
    method: 'கொடுப்பனவு முறை',
    reference: 'குறிப்பு',
    exportExcel: 'எக்செல் ஏற்றுமதி',
    memberDetails: 'உறுப்பினர் விவரங்கள்',
    familyDetails: 'குடும்ப விவரங்கள்',
    paymentDetails: 'கொடுப்பனவு விவரங்கள்',
    makePayment: 'கொடுப்பனவு செய்யுங்கள்',
    confirmPayment: 'கொடுப்பனவு உறுதிப்படுத்து',
    paymentSuccess: 'கொடுப்பனவு வெற்றிகரமாக!',
    viewFamilyTree: 'குடும்ப மரத்தைக் காண்க',
    generation: 'தலைமுறை',
    search: 'தேடு',
    filter: 'வடிகட்டு',
    all: 'அனைத்தும்',
    paid: 'செலுத்தப்பட்டது',
    pending: 'நிலுவையில்',
    overdue: 'காலாவதி',
    emailConfirmation: 'மின்னஞ்சல் உறுதிப்படுத்தல் அனுப்பப்பட்டது',
    profileUpdated: 'சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
    memberAdded: 'உறுப்பினர் வெற்றிகரமாக சேர்க்கப்பட்டார்',
    email: 'மின்னஞ்சல்',
    selectLanguage: 'மொழி',
    myProfile: 'என் சுயவிவரம்',
    taxAmount: 'வரி தொகை',
    annualTax: 'வருடாந்திர வரி பங்களிப்பு',
    viewAll: 'அனைத்தையும் காண்க',
    close: 'மூடு',
    changePassword: 'கடவுச்சொல்லை மாற்று',
    oldPassword: 'தற்போதைய கடவுச்சொல்',
    newPassword: 'புதிய கடவுச்சொல்',
    confirmPassword: 'புதிய கடவுச்சொல்லை உறுதிப்படுத்து',
    resetPassword: 'கடவுச்சொல் மீட்டமை',
    defaultPassword: 'இயல்புநிலை கடவுச்சொல்',
    passwordChanged: 'கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது',
    passwordReset: 'கடவுச்சொல் வெற்றிகரமாக மீட்டமைக்கப்பட்டது',
    passwordMismatch: 'கடவுச்சொற்கள் பொருந்தவில்லை',
    defaultPasswordNote: 'இயல்புநிலை கடவுச்சொல் தொலைபேசி எண். உள்நுழைந்த பிறகு உறுப்பினர் மாற்றலாம்.',
    memberId: 'உறுப்பினர் எண்',
    announcements: 'அறக்கட்டளை அறிவிப்புகள்',
    upcomingEvents: 'வரவிருக்கும் நிகழ்வுகள்',
    meetings: 'கூட்டங்கள்',
    contentManagement: 'உள்ளடக்க மேலாண்மை',
    tamilTyping: 'தமிழ் தட்டச்சு'
  }
};
